import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'hubs.admissions.application-requirements.title',
    defaultMessage: `Application Requirements`,
  },
  subtitle: {
    id: 'hubs.admissions.application-requirements.subtitle',
    defaultMessage: `These are items that the institution requires, recommends, or are optional in the application process.`,
  },
  optionFreshman: {
    id: 'hubs.admissions.application-requirements.option.freshman',
    defaultMessage: `Freshman`,
  },
  optionTransfer: {
    id: 'hubs.admissions.application-requirements.option.transfer',
    defaultMessage: `Transfer`,
  },
  optionInternational: {
    id: 'hubs.admissions.application-requirements.option.international',
    defaultMessage: `International`,
  },
  columnRequired: {
    id: 'hubs.admissions.application-requirements.column.required',
    defaultMessage: `Required`,
  },
  columnRecommended: {
    id: 'hubs.admissions.application-requirements.column.recommended',
    defaultMessage: `Recommended`,
  },
  columnOptional: {
    id: 'hubs.admissions.application-requirements.column.optional',
    defaultMessage: `Optional`,
  },
});

export default messages;
